module.exports = __webpack_public_path__ + "static/media/brand-banner-3.e0b8ee15.png";